<template>
  <div
    v-if="hasAccess"
    class="fill-height"
  >
    <div
      v-for="(item, key) in chartData"
      :key="key"
      class="mb-4"
    >
      <div v-if="ready">
        <v-card>
          <v-card-title>
            {{ item.machineDisplayName }}
          </v-card-title>
          <v-chart
            type="area"
            height="350"
            :options="chartOptions"
            :series="item"
          />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';
import apiUtil from '../utils/ApiUtil';
import { Class as PollerUtil } from '../utils/PollerUtil';

export default {
  components: {
    'v-chart': VueApexCharts,
  },
  data: () => {
    return {
      permissionsKey: 7,
      ready: false,
      data: null,
      pollerUtil: new PollerUtil(),
      chartOptions: {
        colors: ['#81C784', '#E57373'],
        chart: {
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000,
            },
          },
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        markers: {
          size: 0,
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false,
          },
        },
        yaxis: {
          labels: { formatter: (value) => { return value ? 'on' : 'off'; } },
          tickAmount: 1,
          min: 0,
          max: 1,
        },
        legend: {
          show: false,
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy HH:mm:ss',
          },
        },
        fill: {
          type: 'solid',
        },
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    chartData() {
      if (!this.data) {
        return [];
      }
      const chartData = {};
      for (const i in this.data) {
        const microcontroller = this.data[i];
        if (!chartData[i]) {
          chartData[i] = {};
          chartData[i].machineDisplayName = microcontroller.machineDisplayName;
        }
        for (const item of microcontroller.on) {
          if (!chartData[i].on) {
            chartData[i].on = [];
          }

          chartData[i].on.push([moment(item.timestamp).valueOf(), item.on]);
        }

        for (const item of microcontroller.working) {
          if (!chartData[i].working) {
            chartData[i].working = [];
          }
          chartData[i].working.push([moment(item.timestamp).valueOf(), item.working]);
        }
      }

      const prepared = {};
      for (const [key, item] of Object.entries(chartData)) {
        prepared[key] = [{ name: this.$vuetify.lang.t('$vuetify.workingStatus'), data: item.working }, { name: this.$vuetify.lang.t('$vuetify.powerStatus'), data: item.on }];
        prepared[key].machineDisplayName = item.machineDisplayName;
      }

      return prepared;
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.refresh();
    this.$store.dispatch('setGlobalLoading', false);

    this.pollerUtil.interval(1000).exec(
      async () => {
        await this.refresh();
      },
    );

    setTimeout(() => { this.ready = true; }, 100);
  },
  async destroyed() {
    this.pollerUtil.end();
  },
  methods: {
    async refresh() {
      const response = await apiUtil.getLatest100GraphStat();
      this.data = response;
    },
  },
};
</script>
